import { m, type MChild } from '../../mithril';
import type { MithrilVNode } from '../../mithril';
import type { MaterialIcon } from '../icon/icons';
import { Icon } from '../icon/index';
import { addStyles } from '../theme';
import type { MenuComponent } from './menu';
import { CSS, Style } from './menu.item.style';

addStyles(Style);

export interface MenuItem {
	action?: () => any;
	visible?: boolean;
	disabled?: boolean;
	selected?: boolean;
	divider?: boolean;
	component?: boolean;
	view: MithrilVNode;
	id?: string;
	/** Stable hook for E2E selectors (rendered as data-testid), so specs never match on label text. */
	testId?: string;
}

export const MenuItemWrapperComponent = {
	view(menu: MenuComponent, item: MenuItem, selected: boolean): MithrilVNode {
		let onclick: ((ev: MouseEvent) => any) | undefined = undefined;
		let onmousedown: ((ev: MouseEvent) => any) | undefined = undefined;
		if (!item.disabled && item.action != null) {
			onclick = () => {
				menu.hide();
				item.action?.();
			};
			onmousedown = (ev: MouseEvent) => ev.preventDefault();
		}
		return m(
			'div',
			{
				className: `${CSS.item} ${item.visible === false ? CSS.hidden : ''} ${selected ? CSS.selected : ''} ${item.disabled ? CSS.disabled : ''}`,
				onmouseenter: () => menu.selectItem(item),
				onmousedown,
				onclick,
				id: item.id,
				'data-testid': item.testId ?? 'menu-item',
			},
			item.view
		);
	},
};

export const MenuItemComponent = {
	view(text: MChild | MChild[], icon?: MaterialIcon): MithrilVNode {
		const items: MChild[] = [];
		if (icon) {
			items.push(Icon.view(icon));
		}
		if (Array.isArray(text)) {
			items.push(...text);
		} else {
			items.push(text);
		}
		return m.fragment({}, items);
	},
};
